import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'isoCountry' })
export class IsoCountriesPipe implements PipeTransform {
  transform(value, args?: string[]): any {
    let rval;
    switch (value) {
      case 'i0':
        rval = 'un';
        break;
      case 'wa':
        rval = 'gb-wls';
        break;
      case 'sw':
        rval = 'se';
        break;
      case 'dn':
        rval = 'dk';
        break;
      case 'en':
        rval = 'gb-eng';
        break;
      case 'sf':
        rval = 'gb-sct';
        break;
      default:
        return value;
    }
    return rval;
  }
}
